






































































































































import {Component, Vue, Watch, Prop} from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import Note from '@/app/ui/components/Note/Note.vue'
import BackIcon from '@/app/ui/assets/icon_back.vue'
import controller, {
  VoucherConfigSetLimitInterface,
} from '@/app/ui/controllers/VoucherConfigSetLimitController'
import {Utils} from '@/app/infrastructures/misc/Utils'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import ModalUploadBulkyVoucherSKU from "@/app/ui/views/Voucher/components/ModalUploadBulky/UploadBulkyVoucherSKU.vue"
import {EnumStatusUpload} from '@/app/infrastructures/misc/Constants/upload'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import {
  EnumFilterStatusPreviewUploadBulky,
  EventBusConstants,
  PREVIEW_UPLOAD_BULKY_DEFAULT_PAGINATION,
} from '@/app/infrastructures/misc'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import ModalAction from '@/app/ui/components/Modal/ModalAction.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import SuccessIcon from '@/app/ui/assets/success_icon_modal.vue'
import {Dictionary} from 'vue-router/types/router'
import CardUploadResult from '@/app/ui/components/Card/CardUploadResult.vue'
import CloseLine from '@/app/ui/assets/close_icon_line.vue'
import {UploadBulkyVoucherSKU} from "@/domain/entities/VoucherConfigSKU";
import {UploadBulkyVoucherSetLimitSpecificCustomer} from "@/domain/entities/VoucherConfigSetLimit";
import {DataObject, HeaderObject} from "@/app/ui/components/DataTableV2/type";
import DataTableV2 from "@/app/ui/components/DataTableV2/index.vue";

interface NoteInterface {
  type: 'normal' | 'failed' | 'success'
  text: string
  isVisible: boolean
}

interface ReportInterface {
  fileName: string
  totalRowInvalid: string | number
  totalRowValid: string | number
  totalValidAmountNegative: string
  totalValidAmountPositive: string
  totalInvalidAmountNegative: string
  totalInvalidAmountPositive: string
}

interface statusOptionInterface {
  label: string
  value: EnumFilterStatusPreviewUploadBulky
}

interface parametersInterface {
  page: number
  perPage: number
  status: statusOptionInterface
}

interface perPageOptionInterface {
  label: string
  value: number
}

interface queriesInterface {
  page: string
  perPage: string
  status: string
}

interface modalInfoInterface {
  visible: boolean
  title: string
  dataFailed: Array<string | number>
  textButton: string
}

@Component({
  components: {
    DataTableV2,
    CloseLine,
    Button,
    BackIcon,
    Note,
    LoadingOverlay,
    ModalUploadBulkyVoucherSKU,
    DropdownSelect,
    PaginationNav,
    ModalAction,
    Modal,
    SuccessIcon,
    CardUploadResult,
  },
})
export default class PreviewUploadBulkModal extends Vue {
  @Prop({type: Boolean, default: false}) isDisplayModalBlock!: boolean
  @Prop({type: Boolean, default: false}) showModalUploadFile!: boolean

  note: NoteInterface = {
    type: 'normal',
    text: '',
    isVisible: false,
  }
  report = {
    fileName: '-',
    totalRowInvalid: '-',
    totalRowValid: '-',
    totalValidAmountNegative: '-',
    totalValidAmountPositive: '-',
  }
  showUploadModal = false
  statusOptions: Array<statusOptionInterface> = [
    {
      label: 'Semua',
      value: EnumFilterStatusPreviewUploadBulky.ALL,
    },
    {
      label: 'Valid',
      value: EnumFilterStatusPreviewUploadBulky.VALID,
    },
    {
      label: 'Invalid',
      value: EnumFilterStatusPreviewUploadBulky.INVALID,
    },
  ]
  parameters: parametersInterface = {
    page: 1,
    perPage: 10,
    status: this.statusOptions[0],
  }
  controller = controller
  perPageOptions: Array<perPageOptionInterface> = [
    {
      label: '50',
      value: 50,
    },
  ]
  modalInfo: modalInfoInterface = {
    visible: false,
    title: '',
    dataFailed: [0, ''],
    textButton: '',
  }
  isModalSuccessVisible = false
  headers: HeaderObject[] = [
    {
      title: 'No',
    },
    {
      title: 'Customer ID',
    }
  ]
  dataItems: DataObject[][] = []
  customerIds: number[] = []

  get isProcessing(): boolean {
    return (
      controller.statusUploadBulky === EnumStatusUpload.PROCESSING &&
      !controller.forceStart
    )
  }

  private handleBack(): void {
    this.$router
      .push({name: 'VoucherConfigMainPage'})
      .catch(() => false)
  }

  @Watch('controller.responseUploadBulky', {immediate: true, deep: true})
  onResponseUploadBulky(val: UploadBulkyVoucherSetLimitSpecificCustomer | null): void {
    if (!val) return
    let countRowInvalid = 0
    let countRowValid = 0
    this.dataItems = []
    this.customerIds = []
    this.note = {
      type: 'success',
      text: ``,
      isVisible: false,
    }
    val.data.forEach((item, index) => {
      if (item.status.toLowerCase() !== 'valid') {
        countRowInvalid++
      } else {
        countRowValid++
      }

      this.dataItems.push([
        {
          value: index + 1,
          width: '40px',
        },
        {
          value: item.customerId,
          width: '100px',
        },
        // {
        //   value: item.status,
        //   width: '100px',
        // }
      ])
      this.customerIds.push(item.customerId)
    })
    this.report = {
      fileName: val.result.fileName,
      totalRowInvalid: String(countRowInvalid),
      totalRowValid: String(countRowValid),
      totalValidAmountPositive: String(countRowValid),
      totalValidAmountNegative: String(countRowInvalid),
    }

    this.note = {
      type: 'success',
      text: `All data is correct. Please click Send Data button to submit data`,
      isVisible: true,
    }

    if (countRowInvalid > 0) {
      this.note = {
        type: 'failed',
        text: `${countRowInvalid} rows invalid. Please fixing your data and reupload`,
        isVisible: true,
      }
    }
    controller.setStatusUpload(EnumStatusUpload.START)
  }

  private actionModalUpload(): void {
    this.showUploadModal = true
  }

  get isDisabledButtonSendData(): boolean {
    return (
      Number(this.report.totalRowInvalid) !== 0 ||
      Number(this.report.totalRowValid) === 0
    )
  }

  private handleSendData(): void {
    this.note = {
      type: 'success',
      text: ``,
      isVisible: false,
    }

    if (!this.isDisabledButtonSendData) {
      this.$emit('get-data', this.customerIds)
    }
  }

  private closeModalSuccess(): void {
    this.controller.setStatusUpload(EnumStatusUpload.START)
    this.isModalSuccessVisible = false
    this.handleBack()
  }

  get params(): VoucherConfigSetLimitInterface {
    return {
      sort: 'DESC',
    }
  }

  @Watch('params')
  onParamsChanged(
    val: Dictionary<string | (string | null)[] | null | undefined> | undefined
  ): void {
    this.$router
      .replace({
        query: {...val},
      })
      .catch(() => false)
  }

  private fetchPreviewUploadBulky(resetPage = false): void {
    if (resetPage) {
      this.parameters.page = 1
    }

    // this.controller.getPreviewUploadBulky(this.params)
  }

  private resetModalInfo(): void {
    this.modalInfo = {
      visible: false,
      title: '',
      dataFailed: [0, ''],
      textButton: '',
    }
  }

  private handleAction(): void {
    if (this.controller.isLoading) return
    switch (this.modalInfo.textButton) {
      case 'Coba Lagi':
        this.handleSendData()
        break
      case 'Lihat Detail':
        this.resetModalInfo()
        this.$router
          .push({
            name: 'AdjustmentParcelPoinRequestPoinPage',
            query: {tab: 'upload-bulky'},
          })
          .catch(() => false)
        break
    }
  }

  private closeUploadModal(refetch?: boolean): void {
    this.showUploadModal = false
    if (refetch === true) {
      this.fetchPreviewUploadBulky(true)
    }
  }

  beforeDestroy(): void {
    this.controller.setStatusUpload(EnumStatusUpload.START)
    this.controller.setDatRetry(NaN)
    this.controller.setUploadFile(null)
  }
}
